module.exports = __webpack_public_path__ + "static/media/34.dd332e5.wav";


//////////////////
// WEBPACK FOOTER
// ./src/assets/audio/34.wav
// module id = 70KS
// module chunks = 0